export default __webpack_public_path__ + "static/media/modal-icon-game-result-1GB.70e3685d.svg";